module.exports = __webpack_public_path__ + "static/media/2024 FC2_FLEXCatalog_ _002_003_English.52c05b78.pdf";